/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import moment from 'moment-timezone';

export const WORK_DURATION_GRACE_HOURS = 6;

export const MAX_WORK_DURATION_ERROR_MESSAGE =
  'Clock out is blocked because this session exceeds the maximum allowed duration (shift length plus 6 hours). Submit an attendance adjustment with a past clock-out time instead.';

export function getMaxAllowedDurationHours(shiftLengthHours: number): number {
  return shiftLengthHours + WORK_DURATION_GRACE_HOURS;
}

export function isWorkDurationWithinLimit(
  punchInDate: string,
  punchInTime: string,
  punchInTimezone: string,
  punchOutDate: string,
  punchOutTime: string,
  punchOutTimezone: string,
  maxDurationHours: number,
): boolean {
  const punchIn = moment.tz(`${punchInDate}T${punchInTime}`, punchInTimezone);
  const punchOut = moment.tz(
    `${punchOutDate}T${punchOutTime}`,
    punchOutTimezone,
  );

  if (!punchIn.isValid() || !punchOut.isValid()) {
    return true;
  }

  return punchOut.diff(punchIn, 'seconds') <= maxDurationHours * 3600;
}
